import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  SvgIcon,
  Box,
  CircularProgress,
} from "@mui/material";
import styles from "./Ucat_testGrid.module.scss";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { listPracticeTest } from "../../Redux/Slices/PracticeTest/ListPracticeTestSlice";
import { decode } from "../../Utils/encodeDecode";
import { useNavigate } from "react-router-dom";
import { ILoginResponse } from "../Login/ILogin";
import { listEvaluationPracticewritingExam } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticewritingExamSlice";
import IconButtonField from "../../Components/Button/IconButtonField";
import { listEvaluationPractice } from "../../Redux/Slices/PracticeExam/ListEvaluationPracticeSlice";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { listInstructionPracticeExamID } from "../../Redux/Slices/PracticeExam/ListinstructionPracticeExamIDSlice";
import { addStudentExamPractice } from "../../Redux/Slices/StudentExamPractice/AddStudentExamPracticeSlice";
import { clearEditStudentExamPracticeResponse } from "../../Redux/Slices/StudentExamPractice/EditStudentExamPracticeSlice";
import { listUserExamList } from "../../Redux/Slices/UserPackage/ListUserExamListSlice";
import { ReactComponent as Examattemped } from "./ImageMiniMockExampage/Examattemped.svg";
import { clearListExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import { listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import { addStudentExam, clearAddStudentExamResponse } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import Report from "./ImageMiniMockExampage/tabler_report-analytics.png";
import paperlist from "./ImageMiniMockExampage/paperexamlist.png";
import Mockexamimage from "./ImageMiniMockExampage/Mockexamimage1.svg";
import Mockexamimage2 from "./ImageMiniMockExampage/Mockexamimage2.svg";
import Mockexamimage3 from "./ImageMiniMockExampage/Mockexamimage3.svg";
import Mockexamimage4 from "./ImageMiniMockExampage/Mockexamimage4.svg";

import { clearListReExamID, listReExamID } from "../../Redux/Slices/ReExam/ListReExamSlice";
import { clearlistStudentExam } from "../../Redux/Slices/StudentExam/ListStudentExamSlice";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import Menus from "../../Components/Menu/Menu";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import Avatars from "../../Components/Avatar/Avatars";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { AddSubscription } from "../../Redux/Slices/Subscription/AddSubscriptionSlice";
import { listSubscription } from "../../Redux/Slices/Subscription/ListSubscriptionSlice";
import { pendingExamList } from "../../Redux/Slices/UserPackage/PendingExamListSlice";
import { ReactComponent as document_icon } from "../../Assets/Images/document_icon.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import useNavigationBlocker from "../../Hooks/useNavigationBlocker";

const UCAT_TestPage = () => {
  const { data: listPracticeExams } = useAppSelector(
    (state) => state.ListPracticeTestSlice
  );
  useNavigationBlocker(true);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [details, setDetails] = useState<ILoginResponse>({});
  const images = [
    Mockexamimage,
    Mockexamimage2,
    Mockexamimage3,
    Mockexamimage4,
  ];
  dayjs.extend(utc);
  dayjs.extend(timezone);

  const offsetMinutes = dayjs().tz(dayjs.tz.guess()).utcOffset();

  const { data: listUserExamListSlice } = useAppSelector(
    (state) => state.ListUserExamListSlice
  );

  // Get loading state for student exam API
  const { isLoading: isStudentExamLoading } = useAppSelector(
    (state) => state.AddStudentExamSlice
  );
  const Packagess: any = Array.isArray(listUserExamListSlice?.data)
    ? listUserExamListSlice?.data
      .filter((user) => !user.expired) // Filter out courses where expiry is false
      .map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];

  const { data: listUserPackageSlice } = useAppSelector(
    (state) => state.ListUserPackageSlice
  );
  const Packages: any = Array.isArray(listUserPackageSlice?.data)
    ? listUserPackageSlice?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  const { data: SubscriptionSlice, isLoading: scriptionSlice } = useAppSelector(
    (state) => state.ListSubscriptionSlice
  );
  const Subcriptiondetails: any = SubscriptionSlice;

  const { data: pendingExams } = useAppSelector(
    (state) => state.PendingExamList
  );

  useLayoutEffect(() => {
    if (Subcriptiondetails?.status === true) {
      navigate("/subscribedPages");
    }
  }, [Subcriptiondetails]);

  useEffect(() => {
    dispatch(listUserExamList());
    dispatch(pendingExamList());
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  function formatDuration(duration: any) {
    if (!duration) return ""; // Handle empty input gracefully

    return duration
      .replace("minutes", "min")
      .replace("minute", "min")
      .replace("hours", "hr")
      .replace("hour", "hr")
      .replace("seconds", "sec")
      .replace("second", "sec");
  }

  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);

  const [startExamTriggered, setStartExamTriggered] = useState(false);
  const [selectedExamId, setSelectedExamId] = useState<number | null>(null);

  const { data: studentExamData } = useAppSelector(
    (state) => state.AddStudentExamSlice
  );

  useEffect(() => {
    if (startExamTriggered && studentExamData && selectedExamId) {
      // API call successful, proceed to navigation
      // dispatch(clearListExamID());
      navigate("/ucat_start_exam", {
        replace: true,
        state: {
          exam_id: selectedExamId,
          isNew: true,
          examMode: 'new',
          startNow: true
        },
      });
      // Reset trigger
      setStartExamTriggered(false);
      setSelectedExamId(null);
      // dispatch(clearAddStudentExamResponse());
    }
  }, [studentExamData, startExamTriggered, selectedExamId, dispatch, navigate]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];

  return (
    <div className={styles.MinMockStudentAlingment}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <div className="DashboardStudent">UCAT Test</div>
          <div className={styles.StudentPractice}>
            Complete full-length exams that simulate the real test experience
          </div>
        </div>
        <div>
          <Menus
            menuItems={[
              // {
              //   menu: "Profile",
              //   onClick: () => {
              //     nav("/studentprofile");
              //   },
              // },
              {
                menu: "Logout",
                onClick: () => {
                  sessionStorage.clear();
                  dispatch(clearListuser());
                  dispatch(clearLoginStatus());
                  dispatch(clearDashboardChart());
                  navigate("/login");
                },
              },
            ]}
          >
            <IconButtonField onClick={() => { }}>
              <Avatars sx={{ height: "2rem", width: "2rem" }} />
            </IconButtonField>
          </Menus>
          <span className="Username">{ListUser[0]?.student_name}</span>
        </div>
      </div>

      <Grid container spacing={3}>
        {Packagess?.length > 0 ? (
          Packagess.map((course: any) =>
            course?.exams?.map((card: any, idx: number) => (
              <Grid item xs={12} sm={12} md={6} lg={3} key={card.exam_id}>
                <Card className={styles.card} sx={{ boxShadow: "none" }}>
                  <div
                    style={{
                      position: "relative",
                      display: "inline-block",
                      height: "175px",
                    }}
                  >
                    <img
                      src={images[idx % images.length]}
                      alt="Mock Exam"
                      style={{
                        width: "auto",
                        height: "90%",
                        borderRadius: "10px 10px 0px 0px",
                      }}
                    />
                    {/* <div
                      title="Attempt Count"
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "black",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "15px",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    > */}
                    {/* <span>{card?.retake_count}</span> */}
                    {card?.student_exam_id === null ? null : (
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          background:
                            card?.view_report !== null
                              ? "white"
                              : "transparent",
                          // color: "white",
                          borderRadius: "5px",
                          fontSize: "14px",
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <IconButtonField
                          toolTip="Report"
                          onClick={() => {
                            navigate("/ucat_testevaluation", {
                              state: { studentExamId: card?.student_exam_id },
                            });
                          }}
                        >
                          <AssessmentIcon />
                        </IconButtonField>
                      </div>
                    )}

                    {/* </div> */}
                  </div>

                  <CardContent className={styles.cardBody}>
                    <div
                      className={styles.mockexamname}
                      style={{ fontWeight: 600, fontSize: "18px" }}
                    >
                      {card.gate_exam === false ? "UCAT Exam" : card.exam_name}
                    </div>

                    <Typography
                      variant="body2"
                      className={styles.mockexamndescription}
                      sx={{ minHeight: "4em !important" }}
                    >
                      <p
                        style={{
                          minWidth: 0,
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "normal",
                          overflowWrap: "anywhere",
                          fontSize: "14px",
                          margin: "0",
                        }}
                      >
                        {card.exam_description}
                      </p>
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        // marginBottom: "8px",
                        width: "100%",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          color: "#6b7280",
                          borderRadius: "20px",
                          fontSize: "15px",
                          // padding: "5px",
                          gap: "3px",
                          display: "flex",
                        }}
                        title={`Question count : ${card?.question_count}`}
                      >
                        <SvgIcon
                          component={document_icon}
                          inheritViewBox
                          sx={{
                            fill: "none",
                            fontSize: "16px",
                            marginTop: "3px",
                          }}
                        />
                        {card?.question_count} questions
                      </div>
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "5px",
                        }}
                      >
                        <AccessTimeIcon
                          fontSize="large"
                          sx={{
                            fontSize: "15px",
                            fontWeight: 600,
                            color: "#6b7280",
                          }}
                        />{" "}
                        <span
                          style={{
                            marginLeft: "4px",
                            fontSize: "15px",
                            color: "#6b7280",
                          }}
                        >
                          {formatDuration(card.total_timing)}
                        </span>
                      </span>
                    </div>

                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "20px",
                      }}
                    >
                      {(() => {
                        const pendingExam =
                          Array.isArray(pendingExams) &&
                          pendingExams.find(
                            (p: any) => p.exam_id === card.exam_id && !p.closed
                          );

                        if (pendingExam) {
                          return (
                            <Button
                              variant="contained"
                              color="primary"
                              className={styles.pagebutton}
                              onClick={() => {
                                // Set pending exam mode and resume state
                                sessionStorage.setItem("exam_mode", "pending");
                                sessionStorage.setItem("ucat_exam_mode", "pending");
                                sessionStorage.setItem("exam_id", card?.exam_id);
                                sessionStorage.setItem("student_exam_id", card?.student_exam_id);
                                sessionStorage.setItem("resume_exam", "true");

                                dispatch(clearListExamID());
                                navigate("/ucat_pending_exam", {
                                  replace: true,
                                  state: {
                                    exam_id: card?.exam_id,
                                    student_exam_id: card?.student_exam_id,
                                    isResume: true,
                                    examMode: 'pending'
                                  },
                                });

                                // Clear session storage for fresh start
                                sessionStorage.removeItem("pending_time");
                                sessionStorage.removeItem("remain_time");
                                sessionStorage.removeItem("response");
                                sessionStorage.removeItem("question_id");
                                sessionStorage.removeItem("question_type");
                                dispatch(clearlistStudentExam());
                              }}
                            >
                              <img
                                src={paperlist}
                                alt="Pending"
                                style={{ marginRight: "5px" }}
                              />
                              Proceed At {pendingExam?.answered_percentage}%
                            </Button>
                          );
                        } else if (card?.retake_count > 0) {
                          return (
                            <Button
                              variant="contained"
                              color="primary"
                              className={styles.pagebutton}
                              onClick={() => {
                                // Clear previous state and set retake mode
                                sessionStorage.setItem("exam_mode", "retake");
                                sessionStorage.setItem("ucat_exam_mode", "retake");
                                sessionStorage.setItem("exam_id", card?.exam_id);
                                sessionStorage.setItem("student_exam_id", card?.student_exam_id);

                                // Trigger retake API first
                                const userDetails = decode(sessionStorage.getItem("details"));
                                const student_id = userDetails?.id;
                                const offsetMinutes = new Date().getTimezoneOffset();

                                dispatch(listReExamID({
                                  id: card?.student_exam_id,
                                  onSuccess: (response: any) => {
                                    console.log("Retake API Success Response:", response);
                                    const actualData = response?.data || response;

                                    if (actualData) {
                                      // Send questions to student exam API
                                      const studentData = {
                                        exam_id: actualData?.exam_id || actualData?.id,
                                        student_id: student_id,
                                        closed: false,
                                        questions: actualData?.questions_by_type,
                                        client_tz_offset: offsetMinutes,
                                      };

                                      if (studentData.exam_id) {
                                        dispatch(addStudentExam(studentData));

                                        // Wait 2 seconds for API response before navigation
                                        setTimeout(() => {
                                          dispatch(clearListExamID());
                                          navigate("/ucat_retake_exam", {
                                            replace: true,
                                            state: {
                                              exam_id: card?.exam_id,
                                              student_exam_id: card?.student_exam_id,
                                              isRetake: true,
                                              examMode: 'retake'
                                            },
                                          });
                                        }, 2000);
                                      } else {
                                        console.error("Missing exam_id in studentData", studentData);
                                      }
                                    }
                                  },
                                  onFailure: (error: any) => {
                                    console.error("Failed to retake exam:", error);
                                  }
                                }));

                                // Clear session storage for fresh start
                                sessionStorage.removeItem("pending_time");
                                sessionStorage.removeItem("remain_time");
                                sessionStorage.removeItem("response");
                                sessionStorage.removeItem("question_id");
                                sessionStorage.removeItem("question_type");
                                dispatch(clearlistStudentExam());
                              }}
                              disabled={isStudentExamLoading}
                            >
                              {isStudentExamLoading ? (
                                <>
                                  <CircularProgress size={20} style={{ marginRight: 8 }} />
                                  Preparing Retake...
                                </>
                              ) : (
                                "Retake Exam"
                              )}
                            </Button>
                          );
                        } else {
                          return (
                            <Button
                              variant="contained"
                              color="primary"
                              className={styles.pagebutton}
                              onClick={() => {
                                // Clear previous state and set new exam mode
                                sessionStorage.setItem("exam_mode", "new");
                                sessionStorage.setItem("ucat_exam_mode", "new");
                                sessionStorage.setItem("exam_id", card?.exam_id);
                                sessionStorage.setItem("start_new_exam", "true");

                                // Trigger student exam API immediately
                                const userDetails = decode(sessionStorage.getItem("details"));
                                const student_id = userDetails?.id;
                                const offsetMinutes = new Date().getTimezoneOffset();

                                dispatch(addStudentExam({
                                  exam_id: card?.exam_id,
                                  student_id: student_id,
                                  closed: false,
                                  client_tz_offset: offsetMinutes,
                                }));

                                // Wait for API response via useEffect
                                setStartExamTriggered(true);
                                setSelectedExamId(card?.exam_id);

                                // Clear session storage for fresh start
                                sessionStorage.removeItem("pending_time");
                                sessionStorage.removeItem("remain_time");
                                sessionStorage.removeItem("response");
                                sessionStorage.removeItem("question_id");
                                sessionStorage.removeItem("question_type");
                                sessionStorage.removeItem("student_exam_id");
                                dispatch(clearlistStudentExam());
                              }}
                              disabled={isStudentExamLoading}
                            >
                              {isStudentExamLoading ? (
                                <>
                                  <CircularProgress size={20} style={{ marginRight: 8 }} />
                                  Preparing Exam...
                                </>
                              ) : (
                                "Start Now"
                              )}
                            </Button>
                          );
                        }
                      })()}
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))
          )
        ) : (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card className={styles.card} sx={{ boxShadow: "none" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={Mockexamimage}
                  alt="Mock Exam"
                  style={{
                    width: "100%",
                    height: "97%",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                />
              </div>
              <CardContent className={styles.cardBody}>
                <div className={styles.mockexamname}>
                  No Mock Exams Available
                </div>
                <Typography
                  variant="body2"
                  className={styles.mockexamndescription}
                >
                  Upgrade now to get access to 4 Full Length Mock exams!
                </Typography>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    className={styles.startButton}
                    onClick={() => {
                      dispatch(AddSubscription());
                      dispatch(
                        listSubscription({
                          package_id: Packages[0]?.package_id,
                        })
                      );
                    }}
                  >
                    Upgrade Now!
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default UCAT_TestPage;
